import {createTypes} from 'reduxsauce'
import iconNames from '../theme/icons'

export const priceListsUrl = '/price-lists/manage-price-lists'
export const integrationsUrl = '/my-account/integrations'
export const documentsIntegrationUrl = `${integrationsUrl}/filter/docs`
export const zohoAnalyticsUrl = 'https://www.zoho.com/analytics/'

export const locales = [
  {value: 'en-gb', label: 'United Kingdom', countryCodes: ['gb']},
  {value: 'en-au', label: 'Australia', countryCodes: ['au']},
  {value: 'en-ca', label: 'Canada', countryCodes: ['ca']},
  {value: 'en-nz', label: 'New Zealand', countryCodes: ['nz']},
  {value: 'en', label: 'United States', countryCodes: ['us']},
]

export const apiErrorCodes = {
  // AUTH ERROR CODES - 10xx
  MISSING_CREDENTIALS: 1001,
  INVALID_CREDENTIALS: 1002,
  NO_LOGIN_ACCESS: 1003,
  ACCOUNT_DISABLED: 1004,
  ACCOUNT_OFFLINE: 1005,
  LOGIN_CONCURRENCY_MET: 1006,
  INVALID_CLIENT: 1007,
  ACCOUNT_EXPIRED: 1008,
  PERMISSION_ERROR: 1009,
  ACCOUNT_SIGN_UP: 1010, // the account hasn't finished signing up
  RECAPTCHA_FAILED: 1011,
  TOTP_REQUIRED: 1012,
  TOTP_CODE_INVALID: 1013,
  INVALID_TOKEN: 1014,

  // SIGN UP ERRORS - 11xx
  SIGN_UP_EMAIL_IN_USE: 1101,

  // DATACALL EXCEPTION - 12xx
  CALL_NOT_FOUND: 1201,
  CALL_EXCEPTION: 1202,
  NO_RESULTS_FOUND: 1203,
  NOT_AUTHORISED: 1204,
  NOT_SUPPORTED: 1205,

  DEPENDENCY_ERROR: 1210,
  PARAMETER_ERROR: 1211,

  // SPECIFIC ISSUES - 13xx
  LIMIT_REACHED: 1301,
  PART_USED_IN_PRICING_CALCULATOR: 1303,

  // SUBSCRIPTION ISSUES - 14xx
  FAILED_PAYMENT: 1401,

  // DUMMY error 9k+
  DUMMY_ERROR: 9001,
}

export const templateTypes = {
  TERMS: 1,
  HEADER: 2,
  FOOTER: 3,
  PRODUCTION_NOTES: 4,
  PURCHASING_TERMS: 5,
}

export const prefixTypes = {
  QUOTATION: 0,
  PART_CODE: 1,
  OPPORTUNITY: 2,
  INVOICE: 3,
  CREDIT_NOTE: 4,
  ACTIVITY_THREAD: 5,
  DELIVERY_NOTE: 6,
  RETURN_NOTE: 7,
  PURCHASE_ORDER: 8,
  PURCHASE_ORDER_INVOICE: 9,
  PURCHASE_ORDER_CREDIT_NOTE: 10,
  APPROVAL: 11,
}

export const automaticReminderTypes = {
  QUOTATIONS: 'QUOTATIONS',
  APPROVALS: 'APPROVALS',
}

export const euAlpha2 = [
  'AT', 'BE', 'BG', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'EL', 'HU', 'IE', 'LU', 'MT', 'NL', 'PL',
  'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
]

export const accountingTypes = {
  NONE: {
    id: 0,
    title: 'None',
    proOnly: false,
    local: false,
  },
  SAGE_50: {
    id: 13,
    icon: iconNames.sage,
    title: 'Sage 50',
    proOnly: false,
    local: true,
    supportedFields: {
      status: true,
      balance: true,
      onHold: true,
      creditLimit: true,
      availableCredit: true,
    },
  },
  XERO: {
    id: 5,
    icon: iconNames.xero,
    title: 'Xero',
    proOnly: false,
    local: true,
    supportedFields: {
      status: true,
      balance: true,
    },
  },
  SAGE_ONE: {
    id: 6,
    icon: iconNames.sage,
    title: 'Sage One',
    proOnly: false,
    local: true,
    supportedFields: {
      status: true,
      balance: true,
      onHold: true,
      creditLimit: true,
      availableCredit: true,
    },
  },
  QUICK_BOOKS_ONLINE: {
    id: 7,
    icon: iconNames.quickBooks,
    title: 'QuickBooks',
    proOnly: false,
    local: true,
    supportedFields: {
      balance: true,
      creditLimit: true,
      availableCredit: true,
    },
  },

  PRO_SAGE_50: {
    id: 1,
    icon: iconNames.sage,
    title: 'Sage 50 via Clarity Pro',
    proOnly: true,
    local: false,
    supportedFields: {
      status: true,
      balance: true,
      onHold: true,
      creditLimit: true,
      availableCredit: true,
    },
  },
  PRO_SAGE_200: {
    id: 2,
    icon: iconNames.sage,
    title: 'Sage 200 via Clarity Pro',
    proOnly: true,
    local: false,
    supportedFields: {
      status: true,
      balance: true,
      onHold: true,
      creditLimit: true,
      availableCredit: true,
    },
  },
  PRO_QUICKBOOKS: {
    id: 3,
    icon: iconNames.quickBooks,
    title: 'QuickBooks via Clarity Pro',
    proOnly: true,
    local: false,
    supportedFields: {
      balance: true,
      creditLimit: true,
      availableCredit: true,
    },
  },
  PRO_PASTEL: {
    id: 4,
    icon: iconNames.pastel,
    title: 'Pastel via Clarity Pro',
    proOnly: true,
    local: false,
    // no supported fields !
  },
  PRO_SAGE_200_CSV: {
    id: 8,
    icon: iconNames.sage,
    title: 'Sage 200 via Clarity Pro',
    proOnly: true,
    local: false,
    // no supported fields !
  },
  PRO_XERO_CSV: {
    id: 9,
    icon: iconNames.xero,
    title: 'Xero via Clarity Pro',
    proOnly: true,
    local: false,
    // no supported fields !
  },
  PRO_QUICKBOOKS_ONLINE_CSV: {
    id: 10,
    icon: iconNames.quickBooks,
    title: 'QuickBooks via Clarity Pro',
    proOnly: true,
    local: false,
    // no supported fields !
  },
  PRO_SAGE_ONE_CSV: {
    id: 11,
    icon: iconNames.sage,
    title: 'Sage One via Clarity Pro',
    proOnly: true,
    local: false,
    // no supported fields !
  },
  PRO_KASHFLOW_CSV: {
    id: 12,
    icon: iconNames.kashflow,
    title: 'KashFlow via Clarity Pro',
    proOnly: true,
    local: false,
    // no supported fields !
  },
}

accountingTypes.values = [
  accountingTypes.NONE,
  accountingTypes.SAGE_50,
  accountingTypes.PRO_SAGE_50,
  accountingTypes.PRO_SAGE_200,
  accountingTypes.PRO_QUICKBOOKS,
  accountingTypes.QUICK_BOOKS_ONLINE,
  accountingTypes.PRO_PASTEL,
  accountingTypes.XERO,
]
accountingTypes.forId = (id) => accountingTypes.values.find(t => t.id === id) || accountingTypes.NONE

export const featureToggles = {
  SHOPIFY: 'SHOPIFY',
  HUBSPOT_TRACKING: 'HUBSPOT_TRACKING',
  PRINT_TEMPLATE_EDITOR: 'PRINT_TEMPLATE_EDITOR',
  MULTI_LANGUAGE: 'MULTI_LANGUAGE',
  GOOGLE_DRIVE: 'GOOGLE_DRIVE',
  APPROVALS: 'APPROVALS',
  AUTH_SERVICE: 'AUTH_SERVICE',
  DARK_MODE: 'DARK_MODE',
  PRICING_CALCULATOR: 'PRICING_CALCULATOR',
  PRICING_CALCULATOR_PRICE_LIST: 'PRICING_CALCULATOR_PRICE_LIST',
  QUOTATION_AUTOMATIC_REMINDERS: 'QUOTATION_AUTOMATIC_REMINDERS',
  BULK_INVOICES: 'BULK_INVOICES',
}

export const features = {
  ACTIVATION: 1,

  CONTACT_LIMIT: 101,
  EMAIL_ADDRESSES: 106,
  EMAIL_ADDRESSES_XDOMAIN: 107,

  // Allocatable licences
  MASTER_LICENCE: 200,
  ACTIVITY_LICENCE: 201,
  PRICE_LISTS_LICENCE: 204,
  QUOTING_LICENCE: 205,
  INVOICING_LICENCE: 206,
  PRODUCTION_LICENCE: 207,
  DELIVERIES_LICENCE: 208,
  PURCHASING_LICENCE: 209,
  SALES_LICENCE: 210,
  SALES_PLUS_LICENCE: 211,
  POD_LICENCE: 212,
  MANAGEMENT_LICENCE: 213,
  CONTACTS_LICENCE: 214,
  MOBILE_APP_LOGIN: 215,
  SAGE_50: 217,
  DELIVERY_SCHEDULING: 218,


  // Add-ons (account-wide)
  IMPORT: 301,
  EXPORT: 302,
  WEB_FORMS: 303,
  CLARITY_SYNC: 304,
  EXCHANGE_SYNC: 305,
  OFFICE_CALL_SYNC: 307,
  MULTI_SITE: 309,
  CRM_SYNC: 310,
  QUOTING_SYNC: 311,
  XERO_SYNC: 313,
  BULK_SAVE: 314,
  CONTACT_USER_FIELDS: 315,
  QUOTATION_USER_FIELDS: 316,
  ZOHO_SYNC: 317,
  CONTACT_LISTS: 318,
  ACTIVITY_TYPES: 319,
  ACTIVITY_THREADS: 320,
  GOOGLE_DRIVE: 321,
  PRICING_TEMPLATES: 322,
  COMPLEX_PRICING: 323,
  PRICING_GROUPS: 324,
  ASSEMBLIES: 325,
  WORK_CENTRES: 326,
  LINE_ITEM_JOB_CARDS: 327,
  PARTIAL_DELIVERY_NOTES: 328,
  RETURN_NOTES: 329,
  ALLOCATE_JOB_CARD_OWNERS: 330,
  PART_SUPPLIERS: 331,
  QUICK_BOOKS_SYNC: 332,
  SAGE_SYNC: 333,
  PURCHASING_USER_FIELDS: 334,
  MAILCHIMP_SYNC: 335,
  SEASONAL_VARIANTS: 336,
  HUBSPOT_SYNC: 337,
  ONE_DRIVE_SYNC: 338,
  SHOPIFY_SYNC: 339,
  DELIVERIES_SYNC: 340,
  SALES_ANALYSIS: 341,
  APPROVALS: 344,
  BULK_INVOICING: 345,
  QUOTATION_AUTOMATIC_REMINDERS: 346,

  PRICING_CALCULATORS: 400,
  WIDE_FORMAT_PRINT_CALCULATOR: 401,
}

export const featureIsAllocatable = feature => feature >= 200 && feature < 300

export const CONTACT_REQUIRED_FIELDS = {
  CONTACT_ADD_ADDRESS: 'Address',
  CONTACT_ADD_CITY: 'City',
  CONTACT_ADD_COUNTY: 'County',
  CONTACT_ADD_POST_CODE: 'Post code',
  CONTACT_ADD_COUNTRY: 'Country',
  CONTACT_ADD_PHONE: 'Phone',
  CONTACT_ADD_MOBILE: 'Mobile',
  CONTACT_ADD_EMAIL: 'Email',
  CONTACT_ADD_JOB_TITLE: 'Job title',
  CONTACT_ADD_SALUTATION: 'Salutation',
  CONTACT_ADD_WEBSITE: 'Website',
  CONTACT_ADD_BUSINESS_TYPE: 'Business Type',
  CONTACT_ADD_LEAD_SOURCE: 'Lead Source',
  CONTACT_ADD_ACCOUNT_MANAGER: 'Account Manager',
  CONTACT_ADD_ACCOUNT_NUMBER: 'Account Number',
  CONTACT_ADD_GROUPS: 'Groups',
}

export const ORDER_CREATE_REQUIRED_FIELDS = {
  ORDER_CREATE_JOB_TYPE: 'Job Type',
}

export const OPPORTUNITY_CREATE_REQUIRED_FIELDS = {
  OPPORTUNITY_CREATE_JOB_TYPE: 'Job Type',
}

export const ORDER_QUOTE_REQUIRED_FIELDS = {
  ORDER_QUOTE_EXPECTED_DATE: 'Expected Date',
}

export const ORDER_CONFIRM_REQUIRED_FIELDS = {
  ORDER_CONFIRM_ORDER_NUMBER: 'Order Number',
  ORDER_CONFIRM_REASON: 'Order Reason',
  ORDER_CONFIRM_REQUIRED_DATE: 'Required Date',
  ORDER_CONFIRM_TARGET_DATE: 'Target Completion',
  ORDER_CONFIRM_DELIVERY_ADDRESS: 'Delivery Address',
}

export const PURCHASE_INVOICE_REQUIRED_FIELDS = {
  PURCHASE_INVOICE_SUPPLIER_REFERENCE: 'Supplier Reference',
}

export const DELIVERIES_REQUIRED_FIELDS = {
  DELIVERY_TRACKING_NUMBER: 'Tracking Number',
}

export const SALES_INVOICES_REQUIRED_FIELDS = {
  SALES_INVOICE_REF_INC_ORDER_NUMBER: 'Order Number',
  SALES_INVOICE_REF_INC_JOB_REFERENCE: 'Job Reference',
  SALES_INVOICE_REF_INC_DESCRIPTION: 'Description',
}

export const PURCHASE_INVOICES_REFERENCE_REQUIRED_FIELDS = {
  PURCHASE_INVOICE_REF_INC_REFERENCE: 'Reference',
  PURCHASE_INVOICE_REF_INC_SUPPLIER_REFERENCE: 'Supplier Reference',
  PURCHASE_INVOICE_REF_INC_DESCRIPTION: 'Description',
}

export const PURCHASE_ORDER_REQUIRED_FIELDS = {
  PURCHASE_ORDER_DELIVERY_ADDRESS: 'Delivery Address',
}

export const permissionSets = {
  CONTACTS: 'Contacts',
  ACTIVITIES: 'Activities',
  MESSAGES: 'Messages',
  SALES: 'Sales',
  SALES_V2: 'Sales (Old)',
  PRICES: 'Price Lists',
  QUOTING: 'Quoting',
  PRODUCTION: 'Job Boards',
  PURCHASING: 'Purchasing',
  DELIVERIES: 'Deliveries',
  INVOICING: 'Invoicing',
  ACCOUNT: 'Account',
  WEB_FORMS: 'Web Forms',
  SERVICES: 'Services',
}

export const permissions = {
  MANAGE_DEPARTMENTS: 1001,
  MANAGE_ACTIVITY_TYPE: 1002,
  MANAGE_SEND_ADDRESSES: 1003,
  MANAGE_MESSAGE_TYPES: 1004,
  MANAGE_LOGINS: 1006,
  MANAGE_ROLES: 1007,
  MANAGE_CLARITY_SYNC: 1008,
  MANAGE_WEBSITE_INTEGRATION: 1009,
  MANAGE_TAG: 1010,
  MANAGE_SALES_LAYOUTS_V2: 1011,
  MANAGE_OPPORTUNITIES_V2: 1012,
  MANAGE_OTHER_OPPORTUNITIES_V2: 1013,
  MANAGE_UNOWNED_OPPORTUNITIES_V2: 1014,
  VIEW_WEB_FORMS: 1015,
  MANAGE_WEB_FORMS: 1016,
  MANAGE_SMS_NOTIFICATIONS: 1017,
  SEND_MANUAL_SMS: 1018,
  MANAGE_OPPORTUNITY_STAGES: 1019,
  EXPORT_DATA: 1020,
  EXPORT_FORMS: 1021,
  MANAGE_PRICE_LISTS: 1022,
  MANAGE_PART_CATEGORIES: 1023,
  MANAGE_PARTS: 1024,
  MANAGE_PART_TAGS: 1025,
  MANAGE_COMPANY_LOGO: 1026,
  MANAGE_TAX_CODES: 1027,
  MANAGE_FINANCIAL: 1028,
  MANAGE_ORDER_REASONS: 1029,
  MANAGE_QUOTE_TAGS: 1030,
  MANAGE_BUSINESS_TYPES: 1031,
  MANAGE_COMPANY_GROUPS: 1032,
  MANAGE_PRODUCTS: 1033,
  VIEW_QUOTE_COSTS: 1034,
  MANAGE_PRICING_TEMPLATES: 1035,
  MANAGE_CONTACT_LISTS: 1036,
  MANAGE_CONTACT_LIST_PERMISSIONS: 1037,
  MANAGE_SITES: 1038,
  MANAGE_ORDER_TYPES: 1039,
  MANAGE_RESOURCES: 1040,
  DISMISS_QUOTE_MARGIN_WARNING: 1041,
  DISMISS_QUOTE_ACCOUNT_WARNINGS: 1042,
  CONFIRM_JOBS: 1043,
  BULK_CREATE_INVOICES: 1099,
  EDIT_INVOICES: 1044,
  POST_INVOICES: 1045,
  MARK_INVOICED: 1046,
  MANAGE_TEAMS: 1047,
  MANAGE_SALES_TARGETS_V2: 1048,
  BULK_CLOSE_OPPORTUNITIES_V2: 1049,
  MANAGE_CONTACT_ROLES: 1050,
  MANAGE_REFERRAL_FEES: 1051,
  MANAGE_TEXT_TEMPLATES: 1052,
  MANAGE_QUOTE_SETTINGS: 1053,
  MANAGE_INVOICE_SETTINGS: 1054,
  MANAGE_QUOTE_OWNERSHIP: 1055,
  BULK_SUBSCRIBE_CONTACTS: 1056,
  MANAGE_CONTACT_METHODS: 1057,
  MANAGE_ACCOUNT: 1058,
  MANAGE_QUOTE_ITEM_TAGS: 1059,
  ENTER_ITEM: 1060,
  APPLY_DISCOUNTS: 1061,
  MANAGE_PRICING_GROUPS: 1062,
  MANAGE_ACTIVITY_REASONS: 1063,
  MANAGE_CONTACTS: 1064,
  MANAGE_PRODUCTION_REASONS: 1065,
  MANAGE_PRODUCTION_EMAIL_SETTINGS: 1066,
  MANAGE_PRODUCTION_DEPARTMENTS: 1067,
  MANAGE_PRODUCTION_WORK_CENTRES: 1068,
  MANAGE_JOB_CARDS: 1069,
  MANAGE_DELIVERY_REASONS: 1070,
  MANAGE_DELIVERY_EMAIL_SETTINGS: 1071,
  MANAGE_DELIVERY_NOTES: 1072,
  MANAGE_RETURN_NOTES: 1073,
  MANAGE_DELIVERY_METHODS: 1074,
  MANAGE_PREFIXES: 1075,
  MANAGE_PURCHASE_ORDERS: 1076,
  MANAGE_PURCHASING_SETTINGS: 1077,
  MANAGE_PURCHASING_TAGS: 1078,
  POST_CONTACTS: 1079,
  VIEW_DASHBOARDS: 1080,
  MANAGE_OPPORTUNITY_REASONS: 1081,
  MANAGE_ALL_ALLOCATED_OPPORTUNITIES: 1082,
  MANAGE_UNALLOCATED_OPPORTUNITIES: 1083,
  MANAGE_OPPORTUNITY_SETTINGS: 1084,
  POST_OPPORTUNITIES: 1085,
  MANAGE_SALES_LAYOUTS: 1086,
  MANAGE_SALES_TARGETS: 1087,
  BULK_REMOVE_JOBS_FROM_ORDER_BOOK: 1088,
  MANAGE_JOB_DOCUMENTS: 1089,
  MANAGE_PURCHASE_DOCUMENTS: 1090,
  MANAGE_DELIVERY_SCHEDULING_SETTINGS: 1091,
  MANAGE_POD_ACCOUNTS: 1092,
  AMEND_QUOTES: 1093,
  BULK_CLOSE_QUOTATIONS: 1094,
  MANAGE_2FA_SETTINGS: 1095,
  MANAGE_APPROVALS_SETTINGS: 1096,
  MANAGE_APPROVALS: 1097,
  MANAGE_SUPPORT_TOKENS: 1098,
  MANAGE_PRICING_CALCULATOR_RESOURCES: 1100,
  MANAGE_PRICING_CALCULATOR_CONFIGURATION: 1101,
}

export const SEARCH_BLOCKS = [
  'contacts',
  'companies',
  'activities',
  // 'campaigns',
  // 'opportunities',
  'quotes',
  // 'invoices',
  'purchaseOrders',
]

export const USER_FIELD_PARENT_TYPE = createTypes(`
  CONTACT_FIELD
  QUOTE_FIELD
  PART_FIELD
  QUOTE_ITEM_FIELD
  PURCHASE_ORDER_FIELD
  PURCHASE_ORDER_ITEM_FIELD
`)

const userFieldGroup = (
  id, displayName, parentType, permission, uniqueNames, categorised, friendlyName
) => ({
  id, displayName, parentType, permission, uniqueNames, categorised, friendlyName,
})
//See FieldType.class
export const USER_FIELD_TYPES = {
  CONTACT_USER_FIELD: userFieldGroup(
    0,
    'Contact Field',
    USER_FIELD_PARENT_TYPE.CONTACT_FIELD,
    permissions.MANAGE_TAG,
    true,
    true,
    'Contact Custom Fields'),
  COMPANY_USER_FIELD: userFieldGroup(
    2,
    'Company Field',
    USER_FIELD_PARENT_TYPE.CONTACT_FIELD,
    permissions.MANAGE_TAG,
    true,
    true,
    'Company Custom Fields'),
  SURVEY_FIELD: userFieldGroup(
    1,
    'Survey Question',
    USER_FIELD_PARENT_TYPE.CONTACT_FIELD,
    permissions.MANAGE_WEB_FORMS,
    false,
    false,
    'Survey Questions'),
  QUOTE_USER_FIELD: userFieldGroup(
    3,
    'Quotation Field',
    USER_FIELD_PARENT_TYPE.QUOTE_FIELD,
    permissions.MANAGE_QUOTE_TAGS,
    true,
    true,
    'Quote Custom Fields'),
  QUOTE_ITEM_USER_FIELD: userFieldGroup(
    7,
    'Quotation Item Field',
    USER_FIELD_PARENT_TYPE.QUOTE_ITEM_FIELD,
    permissions.MANAGE_QUOTE_TAGS,
    true,
    true,
    'Quote Item Custom Fields'),
  PURCHASE_ORDER_USER_FIELD: userFieldGroup(
    8,
    'Purchase Order Field',
    USER_FIELD_PARENT_TYPE.PURCHASE_ORDER_FIELD,
    permissions.MANAGE_QUOTE_TAGS,
    true,
    true,
    'Purchase Order Custom Fields'),
  PURCHASE_ORDER_ITEM_USER_FIELD: userFieldGroup(
    9, 'Purchase Order Item Field',
    USER_FIELD_PARENT_TYPE.PURCHASE_ORDER_ITEM_FIELD,
    permissions.MANAGE_QUOTE_TAGS,
    true,
    true,
    'Purchase Order Item Custom Fields'),
}

const userFieldDataType = (id, name) => ({
  id, name,
})

export const USER_FIELD_DATA_TYPES = {
  STRING: userFieldDataType(0, 'text'),
  NUMBER: userFieldDataType(1, 'Number'),
  BOOLEAN: userFieldDataType(2, 'Boolean'),
  LIST: userFieldDataType(3, 'List'),
  DATETIME: userFieldDataType(4, 'Date'),
  MULTI_LIST: userFieldDataType(5, 'Multi List'),
  MEMO: userFieldDataType(6, 'Memo'),
  CURRENCY: userFieldDataType(7, 'Currency'),
  EMAIL: userFieldDataType(8, 'Email'),
  PHONE: userFieldDataType(9, 'Phone'),
  MOBILE: userFieldDataType(10, 'Mobile'),
}

export const MILLISECONDS = {
  '1MIN': 60000,
  '30MINS': 1800000,
  '60MINS': 3600000,
  '90MINS': 5400000,
  '2HOURS': 7200000,
  '3HOURS': 10800000,
  '4HOURS': 14400000,
  '5HOURS': 18000000,
  '6HOURS': 21600000,
  '7HOURS': 25200000,
  '8HOURS': 28800000,
  '9HOURS': 32400000,
  '10HOURS': 36000000,
  '11HOURS': 39600000,
  '12HOURS': 43200000,
  '13HOURS': 46800000,
  '14HOURS': 50400000,
  '15HOURS': 54000000,
  '16HOURS': 57600000,
  '17HOURS': 61200000,
  '18HOURS': 64800000,
  '19HOURS': 68400000,
  '20HOURS': 72000000,
  '21HOURS': 75600000,
  '22HOURS': 79200000,
  '23HOURS': 82800000,
  '24HOURS': 86400000,
  '1DAYS': 86400000,
  '2DAYS': 172800000,
  '3DAYS': 259200000,
  '4DAYS': 345600000,
  '5DAYS': 432000000,
  '6DAYS': 518400000,
  '7DAYS': 604800000,
  '8DAYS': 691200000,
  '9DAYS': 777600000,
  '10DAYS': 864000000,
  '11DAYS': 950400000,
  '12DAYS': 1036800000,
  '13DAYS': 1123200000,
  '14DAYS': 1209600000,
  '15DAYS': 1296000000,
  '16DAYS': 1382400000,
  '17DAYS': 1468800000,
  '18DAYS': 1555200000,
  '19DAYS': 1641600000,
  '20DAYS': 1728000000,
  '21DAYS': 1814400000,
  '22DAYS': 1900800000,
  '23DAYS': 1987200000,
  '24DAYS': 2073600000,
  '25DAYS': 2160000000,
  '26DAYS': 2246400000,
  '27DAYS': 2332800000,
  '28DAYS': 2419200000,
  '29DAYS': 2505600000,
  '30DAYS': 2592000000,
}

export const calculatorInputTypes = {
  PART: 'PART',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  TEXT: 'TEXT',
  RESOURCE: 'RESOURCE',
}

// Helper to get CSS variable color or fallback
const getPartTypeColor = (varName, fallback) => {
  return typeof window !== 'undefined'
    ? getComputedStyle(document.documentElement).getPropertyValue(varName).trim() || fallback
    : fallback
}

export const PartType = {
  MATERIAL: {
    id: 1,
    label: 'Material',
    icon: iconNames.material,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-material', '#3f51b5')
    },
    labour: false,
  },
  LABOUR: {
    id: 2,
    label: 'Labour',
    icon: iconNames.labour,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-labour', '#ff9800')
    },
    labour: true,
  },
  RESOURCE: {
    id: 3,
    label: 'Resource',
    icon: iconNames.resource,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-resource', '#42a5f5')
    },
    labour: true,
  },
  OUTSOURCED: {
    id: 4,
    label: 'Outsourced',
    icon: iconNames.outsourced,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-outsourced', '#ffcc00')
    },
    labour: false,
  },
  NON_STOCK: {
    id: 5,
    label: 'Non-Stock',
    icon: iconNames.nonStock,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-non-stock', '#ab47bc')
    },
    labour: false,
  },
  TIMESHEET: {
    id: 6,
    label: 'Timesheet',
    icon: iconNames.timesheet,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-timesheet', '#666')
    },
    labour: false,
  },
  EXPENSES: {
    id: 7,
    label: 'Expenses',
    icon: iconNames.expenses,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-expenses', '#f44336')
    },
    labour: false,
  },
  ASSEMBLY: {
    id: 8,
    label: 'Assembly',
    icon: iconNames.assembly,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-assembly', '#4caf50')
    },
    labour: false,
  },
  PRO_CALC_WIZARD: {
    id: 9,
    label: 'Calc Wizard (created in Pro)',
    icon: iconNames.calcWizard,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-calc-wizard', '#50E3C2')
    },
    labour: false,
  },
  RENTAL: {
    id: 10,
    label: 'Rental',
    icon: iconNames.rental,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-rental', '#222')
    },
    labour: false,
  },
  SERVICE: {
    id: 11,
    label: 'Service',
    icon: iconNames.service,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-service', '#F85DC8FF')
    },
    labour: false,
  },
  GO_PRICING_CALCULATOR: {
    id: 12,
    label: 'Pricing Calculator',
    icon: iconNames.pricingCalculator,
    get colour() {
      return getPartTypeColor('--cg-color-part-type-pricing-calculator', '#50E3C2')
    },
    labour: false,
  },
}

export const ScalingType = {
  VARIABLE: {
    id: 1,
    label: 'Variable',
  },
  FIXED: {
    id: 2,
    label: 'Fixed',
  },
}

export const PACK_TYPE_LABOUR_LABELS = {
  MINUTES: 'Minutes',
  HOURS: 'Hours',
  DAYS: 'Days',
}

export const PACK_TYPE_LABOUR_MINUTES = {
  MINUTES: 1,
  HOURS: 60,
  DAYS: 1440,
}

// see Module.java
export const modules = {
  CONTACTS_OVERVIEW: 34,
  CONTACTS_MANAGE_DETAILS: 35,
  CONTACTS_MANAGE_CRM: 36,
  CONTACTS_MANAGE_DOCUMENTS: 37,
  CONTACTS_MANAGE_QUOTES: 38,
  CONTACTS_MANAGE_INVOICES: 39,
  CONTACT_LISTS: 40,
  LIST_BUILDER: 41,
  CONTACT_IMPORT: 42,
  ACTIVITIES_AGENDA: 43,
  ACTIVITIES_LIST: 44,
  ACTIVITIES_CALENDAR: 45,
  QUOTING_DASHBOARD: 46,
  QUOTING_VIEW: 47,
  QUOTE_EDITOR: 48,
  QUOTE_PREVIEW: 49,
  INVOICING_VIEW: 50,
  INVOICING_DELIVERED: 51,
  INVOICE_EDITOR: 52,
  INVOICE_PREVIEW: 53,
  SETTINGS: 54,
  CUSTOM_FIELDS: 55,
  LOGINS: 56,
  CONNECTIONS: 57,
  ACCOUNT: 58,
  PURCHASE_INVOICES: 59,
  PURCHASE_ORDER_EDITOR: 60,
  PURCHASE_ORDER_PREVIEW: 61,
  PURCHASE_INVOICE_EDITOR: 62,
}

export const AccountType = {
  SIGN_UP: 0,
  TRIAL: 1,
  CUSTOMER: 2,
  INTERNAL: 3,
  BETA: 5,
  BIN: 6,
  FREE_CUSTOMER: 7,
  MANAGEMENT: 8,
  UNKNOWN: 9000,
}

export const USER_LEVEL = {
  MASTER: 1,
  USER: 2,
  SUPPORT: 3,
}

export const AUTHORISATION_LEVEL = {
  PARTIALLY_AUTHENTICATED: 'PARTIALLY_AUTHENTICATED',
  AUTHENTICATED_ONLY: 'AUTHENTICATED_ONLY',
  TFA_SETUP_REQUIRED: 'TFA_SETUP_REQUIRED',
  ACCOUNT_EXPIRED: 'ACCOUNT_EXPIRED',
  FULLY_AUTHORISED: 'FULLY_AUTHORISED',
}

export const ZOHO_SYNC_STATUS = {
  INACTIVE: 0,
  ACTIVATING: 1,
  ONGOING: 2,
  UNAUTHORISED: 3,
  ERROR: 4,
}

export const ZOHO_REGIONS = [
  {key: 'us', label: 'United States'},
  {key: 'eu', label: 'Europe'},
  {key: 'in', label: 'India'},
  {key: 'au', label: 'Australia'},
  {key: 'cn', label: 'China'},
]

export const PRO_LICENCE = {
  Clarity_Pro: 0,
  Clarity_Lite: 1,
  Clarity_Wizards: 2,
  Quotations: 3,
  Purchase_Orders: 4,
  Price_Lists: 5,
  Activities: 6,
  Marketing: 7,
  Cost_Analysis: 8,
  Goods: 9,
  Invoicing: 10,
  Accounts_Integration: 11,
  Production: 12,
  Reporting: 13,
  Network: 14,
  Remote_User: 15,
  Shop_Floor: 16,
  Nesting: 17, // (discontinued)
  Sales: 18,
  Deliveries: 19,
  Clarity_Nesting: 20,
  Advanced_Accounts_Integration: 21,
  Enterprise: 22,
}
export const priceListsSyncVersion = 6002001008
export const pricingGroupsSyncVersion = 6002002013

export const deliveriesSyncVersion = 6002009000
export const zohoTables = [
  {label: "Companies", value: "COMPANIES", className: "companies"},
  {label: "Contacts", value: "CONTACTS", className: "contacts"},
  {label: "Quotations", value: "QUOTES", className: "quotes"},
  {label: "Quotation Items", value: "QUOTE_ITEMS", className: "quote-items"},
  {label: "Invoices", value: "INVOICES", className: "invoices"},
  {label: "Invoice Items", value: "INVOICE_ITEMS", className: "invoice-items"},
  {label: "Purchase Orders", value: "PURCHASE_ORDERS", className: "purchase-orders"},
  {label: "Purchase Order Items", value: "PURCHASE_ORDER_ITEMS", className: "purchase-order-items"},
]


